import ImageHelper from './helper/ImageHelper';
import VideoHelper from './helper/VideoHelper';
import DataHelper from './helper/DataHelper';
import context from './context';

export default class Loader {

    constructor() {

        this.videoTypes = ['mp4'];
        this.imageTypes = ['jpg', 'png'];
        this.dataTypes = ['json'];

        this.helpers = {};
        this.currentHelper = null;

        this.componentDidMount();
    }

	componentDidMount = () => {
        window.document.addEventListener('gamMap', this.handleMap);
        window.document.addEventListener('gamLinkLoading', this.handleLink);
    }
    
    componentWillUnmount = () => {
        window.document.removeEventListener('gamMap', this.handleMap);
        window.document.removeEventListener('gamLinkLoading', this.handleLink);
    }

    handleMap = (e) => {

        const defaults = {
            map: null,//`${process.env.PUBLIC_URL}/maps/default.jpg`,
            poster: null,
            color: 'a',
            width: 16,
            height: 12,
            depth: 14,
            step: 16,
            random: 0
        }

        const options = Object.assign(defaults, e.detail);
        const { map, poster, color, width, height, depth, random } = options;
        let { step } = options;

        if(map === null) return;

        //console.log('handleMap', options);

        //limit step for phones
        if(context.isPhone && step < 4) step = 4;
        
        //map already loaded? 
        if(this.helpers[map]) {
            this.helpers[map].update({
                url: map, 
                step, color, width, height, depth, random
            }, () => {                    
                this.setHelper(options);
            });
            
        //create new map helper
        } else if(map) {

            const filetype = map.split('.').pop();
            if(this.imageTypes.indexOf(filetype) > -1) {
                this.helpers[map] = new ImageHelper({
                    url: map, 
                    step, color, width, height, depth, random
                }, () => {                    
                    this.setHelper(options);
                });
            } else if(this.videoTypes.indexOf(filetype) > -1) {
                this.helpers[map] = new VideoHelper({
                    url: map, 
                    poster, step, color, width, height, depth, random
                }, () => {
                    this.setHelper(options);
                });
            } else if(this.dataTypes.indexOf(filetype) > -1) {
                this.helpers[map] = new DataHelper({
                    url: map,
                    step, color, width, height, depth, random
                }, () => {
                    this.setHelper(options);
                })
            } else {
                console.error('Map filetype not supported:', map);
            }
        }
    }
    
    handleLink = () => {
        this.currentHelper && this.currentHelper.pause();
    }

    setHelper = (options) => {

        this.currentHelper && this.currentHelper.pause();
        this.currentHelper = this.helpers[options.map];

        const event = new CustomEvent('gamMapLoaded', { detail: { helper: this.currentHelper, options } });
        window.document.dispatchEvent(event);
    }

	render() {
		return null;
	}
}